import LikeList from './LikeList';

export default LikeList;
